import { Component, Input } from '@angular/core';


/** Styles do badge */
interface Styles {
    width?: string
    height?: string;
}

@Component({
    selector: 'sgt-canal-venda-logo-badge',
    templateUrl: './canal-venda-logo-badge.component.html',
    styleUrls: ['./canal-venda-logo-badge.component.less']
})
export class CanalVendaLogoBadgeComponent {
    /** Logo do Canal de Venda */
    @Input() logoURL: string;
    /** Mini logo do Canal de Venda */
    @Input() logoMiniURL: string;
    /** Se deve usar o mini logo */
    @Input() useAsMini = false;
    /** Se deve exibir o nome do Canal de Venda */
    @Input() isShowNome = true;
    /** Nome do Canal de Venda */
    @Input() nome: string;
    /** Styles personalizados do badge */
    @Input() styles: Styles = {
        width: '30px'
    }
}
